import { transition } from 'xstate';

// given a machine (in its current state) and an event, produces the next state (without actually transitioning)
export function getNextState(machine, event) {
  if (!machine || !event) return null;
  const currentState = machine.getSnapshot();
  const [nextState] = transition(machine.logic, currentState, event);
  return nextState;
}
